import { FC } from 'react'
import { Routes } from 'react-router-dom'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { Result } from 'antd'
import mapRouterHelper from '../../utils/MapRouterHelper'
import DocumentRouters from '../document/routers/Document.Routers'
import DMSRouters from '../tai-lieu/DMSRouters'
import QuanLyGiaoViecRouters from '../quan-ly-giao-viec/QuanLyGiaoViecRouters'
import PhanBoTrangThietBiRouters from '../phan-bo-trang-thiet-bi/PhanBoTrangThietBiRouters'
import DatXeRouters from '../dat-xe/DatXe.Routers'
import DatPhongHopRouters from '../dat-phong-hop/DatPhongHop.Routers'

const NotFoundPage: FC = () => (
  <Result status="404" title="404" subTitle="Không tìm thấy trang" />
)

// Các Router không có phân quyền
const otherHrmRouters: AppRouterItem[] = [
  {
    path: `*`,
    element: <NotFoundPage />,
  },
  {
    path: `/not-found`,
    element: <NotFoundPage />,
  },
]

const HRMLayoutRouters: FC = () => (
  <Routes>
    {mapRouterHelper(otherHrmRouters)}
    {mapRouterHelper(DocumentRouters)}
    {mapRouterHelper(DMSRouters)}
    {mapRouterHelper(QuanLyGiaoViecRouters)}
    {mapRouterHelper(PhanBoTrangThietBiRouters)}
    {mapRouterHelper(DatXeRouters)}
    {mapRouterHelper(DatPhongHopRouters)}
  </Routes>
)

export default HRMLayoutRouters
